import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const testimonials = [
  {
    img: "client-03.png",
    name: "Mr. Rahul Sharma",
    location: "Mumbai",
    text: `"Excellent cab service! The driver was professional, the car was clean, and the journey was very comfortable. I always prefer Royal Route Cab for my airport travel."`,
  },
  {
    img: "client-04.png",
    name: "Ms. Priya Mehta",
    location: "Pune",
    text: `"Booked an outstation trip and had a great experience. On-time pickup, smooth ride, and affordable pricing. Highly recommended for family travel!"`,
  },
  {
    img: "client-03.png",
    name: "Mr. Amit Verma",
    location: "Nashik",
    text: `"Very reliable service. I use Royal Route Cab for my business trips. Drivers are polite and always on time. Great service overall!"`,
  },
  {
    img: "client-04.png",
    name: "Ms. Sneha Patil",
    location: "Kolhapur",
    text: `"Clean cars, safe driving, and easy booking via WhatsApp. Perfect cab service for long-distance travel. Will book again!"`,
  },
];

const TestimonialSection = () => {
  return (
    <section className="testimonial-section-4 section-padding text-center bggreen">
      <div className="container">

        {/* Header */}
        <div className="section-title-area text-center">
          <div className="section-title">
            <span className="wow fadeInUp">Customer Testimonials</span>

            <h2 className="wow fadeInUp text-dark text-center" data-wow-delay=".3s">
              What Our Customers Say About <br /> Royal Route Cab
            </h2>
          </div>

         
        </div>

        {/* Slider */}
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={2}
          loop={true}
          autoplay={{ delay: 2500 }}
          breakpoints={{
            320: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
          }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-box-items-4">

                {/* Image */}
                <div className="testi-img">
                  {/* <img
                    src={`/img/testimonial/${item.img}`}
                    alt={item.name}
                  /> */}
                </div>

                {/* Stars */}
                <div className="star">⭐⭐⭐⭐⭐</div>

                {/* Quote Icon */}
                <div className="icon pt-5">
                  <img
                    src="/img/testimonial/quote-01.png"
                    alt="quote"
                  />
                </div>

                {/* Text */}
                <h3>{item.text}</h3>

                {/* Client Info */}
                <div className="client-info">
                  <h4>{item.name}</h4>
                  <span>from {item.location}</span>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
};

export default TestimonialSection;